module.exports = __webpack_public_path__ + "static/media/RoastedPeanuts.c448623f.pdf";